import { ISimpleType, types } from 'mobx-state-tree'

import { placeToString } from './locationsUtils'

export const LocationPoint = types
  .model('LocationPoint', {
    _id: types.frozen as ISimpleType<string>,
    name: types.frozen as ISimpleType<string>,
    description: types.frozen as ISimpleType<string>, // used in manual qr popup
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- // TODO: Replace any with a suitable type
    location: types.frozen as any,
    types: types.frozen as ISimpleType<string[]>,

    place_id: types.frozen as ISimpleType<string>,
    googplace_id: types.frozen as ISimpleType<string>,
    googplace_types: types.frozen as ISimpleType<string[]>,

    fullAddress: types.frozen as ISimpleType<string>,
    companyName: types.frozen as ISimpleType<string>,
    street: types.frozen as ISimpleType<string>,
    street2: types.frozen as ISimpleType<string>,
    streetNumber: types.frozen as ISimpleType<string>,
    city: types.frozen as ISimpleType<string>,
    district: types.frozen as ISimpleType<string>,
    state: types.frozen as ISimpleType<string>,
    country: types.frozen as ISimpleType<string>,
    countryCode: types.frozen as ISimpleType<string>,
    postalCode: types.frozen as ISimpleType<string>,
    googlePlace: types.frozen as ISimpleType<string>,
    locationId: types.frozen as ISimpleType<string>,
  })
  .views((self) => ({
    get string(): string {
      // @ts-expect-error TS(2322) FIXME: Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
      return placeToString(self)
    },
    get locationWithoutCompanyName(): string {
      // In create location form, company name is not required in location field as we have different field for company name
      // @ts-expect-error TS(2322) FIXME: Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
      return placeToString({ ...self, companyName: '' })
    },
    isForCountry(countryCode: string): boolean {
      return self.country === countryCode || self.countryCode === countryCode
    },
  }))

export type TLocationPoint = typeof LocationPoint.Type
